// ---------------------------------------
// PlaylistPlayer.js
// Player that plays a list of videos based on IDs provided by data-playlist attribute + playlist addon for player actions
// ---------------------------------------
import Utils from 'nova-tn-frontend/source/scripts/modules/Utils'
import StickyPlayer from './StickyPlayer'

import { register, pause, play } from '../services/players'

const PlaylistPlayer = {
	position: 0,
	wrapper: $('.js-playlistplayer'),
	player: $('.js-playlistplayer .c-player'),
	playlist: null,
	currentVideo: null,
	currentVideoId: null,
	purpose: false,
	defaultPlayerEmbedUrl: 'https://mediatn.cms.nova.cz', // Default embed player url fallback

	Init: function (purpose) {
		if (typeof window.PageData.playerEmbedUrl == 'undefined') {
			window.PageData.playerEmbedUrl = this.defaultPlayerEmbedUrl
		}
		if (this.wrapper.length < 1) {
			return
		}
		this.purpose = purpose
		this.playlist = PlaylistPlayer.purpose
			? this.player.data('playlist-purpose').split(',')
			: this.player.data('playlist').split(',')

		// const savedPosition = localStorage.getItem('PlaylistPlayerPosition') || this.position;
		const savedPosition = this.position
		const hasPlaylistPlayer = this.player.length > 0
		this.Events.Click.PlaylistChange()

		if (hasPlaylistPlayer) {
			this.position = parseInt(savedPosition)

			this.SetValidPosition()
			this.CreateElement()
			this.Events.Create.KlebetnicaEvents()

			window.onbeforeunload = () => {
				this.ShiftPosition()
			}
		}
	},

	IsPositionValid: function () {
		return this.playlist[this.position]
	},

	SetValidPosition: function () {
		if (!this.IsPositionValid()) {
			this.position = 0
		}
	},

	ShiftPosition: function () {
		this.position += 1

		this.SetValidPosition()
	},

	SetNextVideo: function () {
		var iframe = this.wrapper.find('iframe')

		if (PlaylistPlayer.currentVideo === this.playlist[this.position]) {
			if (!this.playlist[this.position + 1]) {
				return false
			}
		}

		this.ShiftPosition()

		if (iframe.length) {
			this.ChangeVideoSource(iframe, this.playlist[this.position])
		}
	},

	ChangeVideoSource: function (element, videoID) {
		// The pause function prevents the pauseOther function from being executed incorrect due to rapid changes in the iframe source
		// Where the old player is destroyed and playersState ref does not change playing prop properly.
		// This ensures that Klebetnica does not send a pause event, which would pause the currently playing player.

		pause(PlaylistPlayer.currentVideoId)

		element.attr(
			'src',
			`${window.PageData.playerEmbedUrl}/embed/${videoID}?autoplay=1&mute_sound=1`
		)
		element.attr('data-short', videoID)
	},

	CreateElement: function () {
		const params = {
			autoplay: 1,
			mute_sound: 1,
		}
		const embed = this.playlist[this.position]

		this.player.find('.detach-container').append(`
            <iframe
                src="${
					window.PageData.playerEmbedUrl
				}/embed/${embed}?${Utils.EncodeGetParams(params)}"
                data-short="${embed}"
                class="js-player-container js-playlist-player-iframe"
                style="
                    position:absolute !important;
                    top:0 !important;
                    left:0 !important;
                    width:100% !important;
                    height:100% !important;
                    border:0 !important;
                "
                allow="autoplay; fullscreen; encrypted-media; clipboard-read; clipboard-write"
                allowfullscreen=""
            ></iframe>
        `)
	},

	Events: {
		Create: {
			KlebetnicaEvents: function () {
				register((data = {}) => {
					const short = data?.customData?.embed?.short
					const videoId = data?.customData?.videoID
					const { duration, currentTime } = data

					PlaylistPlayer.currentVideoId = videoId

					if (!videoId) {
						return
					}

					if (
						PlaylistPlayer.wrapper
							.find('iframe')
							.attr('data-short') === short
					) {
						const selector = PlaylistPlayer.purpose
							? 'data-playlist-disabled-purpsose-video'
							: 'data-playlist-video'
						const playlistElement = $(
							'[' +
								selector +
								'="' +
								PlaylistPlayer.playlist[
									PlaylistPlayer.position
								] +
								'"]'
						)

						PlaylistPlayer.currentVideo = short

						// eslint-disable-next-line default-case
						switch (data.eventName) {
							case 'play':
								if (
									$(
										'[data-playlist-video-id="' +
											videoId +
											'"]'
									).length
								) {
									$(
										'[data-playlist-video-id="' +
											videoId +
											'"]'
									)
										.removeClass('-paused')
										.addClass('-active')
								}
								break
							case 'init':
								StickyPlayer.Init()
								if (playlistElement.length) {
									playlistElement
										.addClass('-active')
										.removeClass('-loading')
									if (PlaylistPlayer.purpose) {
										$(
											'[data-playlist-disabled-purpsose-video]'
										).removeClass('-loading')
									} else {
										const selector = PlaylistPlayer.purpose
											? 'data-playlist-disabled-purpsose-video'
											: 'data-playlist-video'
										$('[' + selector + ']').removeClass(
											'-loading'
										)
									}
								}
								break
							case 'timeupdate':
								if (!data.ad) {
									PlaylistPlayer.Events.Handlers.HandleTimeState(
										playlistElement,
										currentTime,
										duration,
										videoId
									)
								}
								break
							case 'pause':
								if (duration !== currentTime) {
									$(
										'[data-playlist-video-id="' +
											videoId +
											'"]'
									)
										.removeClass('-active')
										.addClass('-paused')
									return
								}

								PlaylistPlayer.SetNextVideo()
								PlaylistPlayer.Events.Handlers.ClearPlaylistElement(
									playlistElement
								)
								break
							case 'ended':
								PlaylistPlayer.SetNextVideo()
								PlaylistPlayer.Events.Handlers.ClearPlaylistElement(
									playlistElement
								)
								break
						}
					}
				})
			},
		},
		Click: {
			PlaylistChange: function () {
				PlaylistPlayer.wrapper
					.find('.js-toggle-playlist')
					.on('click', function () {
						let videoId =
							$(this).attr('data-playlist-video-id') || ''
						const selector = PlaylistPlayer.purpose
							? 'data-playlist-disabled-purpsose-video'
							: 'data-playlist-video'
						if ($(this).hasClass('-active')) {
							pause(videoId)
							$(this).removeClass('-active').addClass('-paused')
						} else if ($(this).hasClass('-paused')) {
							play(videoId)
							$(this).removeClass('-paused').addClass('-active')
						} else {
							var iframe = PlaylistPlayer.player.find('iframe')
							PlaylistPlayer.wrapper
								.find('.js-toggle-playlist')
								.removeClass('-active')
								.removeClass('-paused')
							$(this).addClass('-loading')

							if (iframe.length) {
								PlaylistPlayer.Events.Handlers.ClearPlaylistElement(
									PlaylistPlayer.wrapper.find(
										'.js-toggle-playlist'
									)
								)

								PlaylistPlayer.ChangeVideoSource(
									iframe,
									$(this).attr(selector)
								)
							}
							PlaylistPlayer.position =
								PlaylistPlayer.playlist.indexOf(
									$(this).attr(selector)
								)
						}
					})
			},
		},
		Handlers: {
			HandleTimeState: function (element, currentTime) {
				const timeToFormat =
					PlaylistPlayer.Events.Handlers.SecondsToTime(currentTime)

				if (currentTime > 0.5) {
					if (!element.find('.time .time-current').length) {
						element
							.find('.time')
							.prepend(
								'<time class="time-current">' +
									timeToFormat +
									'</time>'
							)
					} else {
						element.find('.time .time-current').text(timeToFormat)
					}

					element.find('.duration .bar').css('width', '100%')
				}
			},

			SecondsToTime: function (timeInSeconds) {
				const timeToDate = new Date(timeInSeconds * 1000)
				const minutes = timeToDate.getUTCMinutes()
				const seconds = timeToDate.getSeconds()

				const timeString =
					minutes.toString().padStart(1, '0') +
					':' +
					seconds.toString().padStart(2, '0')

				return timeString
			},

			ClearPlaylistElement: function (element) {
				element.removeClass('-active').removeClass('-paused')
				element.find('.time .time-current').remove()
				element.find('.duration .bar').css('width', '0%')
			},
		},
	},
}

window.PlaylistPlayer = PlaylistPlayer
export default PlaylistPlayer
